import { Button, Row } from "antd";

type FooterProps = {
  isLoading: boolean;
  cancel: () => void;
  print: () => void;
};

export const Footer = ({ isLoading, print, cancel }: FooterProps) => {
  return (
    <Row className="justify-end mt-2 mr-6">
      <Button
        type="primary"
        size="large"
        shape="round"
        disabled={isLoading}
        loading={isLoading}
        onClick={print}
      >
        Select
      </Button>
      <Button
        size="large"
        className="ml-2"
        shape="round"
        disabled={isLoading}
        onClick={cancel}
      >
        Cancel
      </Button>
    </Row>
  );
};
